import type {
  AddReferenceRequest,
  CreateIdentityRequest,
  CreatorBriefDto,
  CreatorBriefInput,
  GenerateReferencesRequest,
  IdentityDto,
  IdentitySummaryDto,
  JobDto,
  ProjectIdentityDto,
  UpdateRevisionRequest,
} from '@gc/shared';
import { apiRequest } from './client.js';

/** Fase 10: identidades virtuales y brief del creador. */
export const listarIdentidades = () => apiRequest<IdentitySummaryDto[]>('/identities');
export const obtenerIdentidad = (id: string) => apiRequest<IdentityDto>(`/identities/${id}`);
export const crearIdentidad = (input: CreateIdentityRequest) => apiRequest<IdentityDto>('/identities', { method: 'POST', body: input });
export const archivarIdentidad = (id: string) => apiRequest<IdentityDto>(`/identities/${id}/archive`, { method: 'POST' });
export const crearRevision = (id: string, input: UpdateRevisionRequest) => apiRequest<IdentityDto>(`/identities/${id}/revisions`, { method: 'POST', body: input });
export const actualizarRevision = (id: string, revisionId: string, input: UpdateRevisionRequest) =>
  apiRequest<IdentityDto>(`/identities/${id}/revisions/${revisionId}`, { method: 'PATCH', body: input });
export const anadirReferencia = (id: string, revisionId: string, input: AddReferenceRequest) =>
  apiRequest<IdentityDto>(`/identities/${id}/revisions/${revisionId}/references`, { method: 'POST', body: input });
export const quitarReferencia = (id: string, revisionId: string, referenceId: string) =>
  apiRequest<IdentityDto>(`/identities/${id}/revisions/${revisionId}/references/${referenceId}`, { method: 'DELETE' });
export const generarReferencias = (id: string, revisionId: string, input: GenerateReferencesRequest) =>
  apiRequest<{ jobs: JobDto[]; estimatedUsd: string }>(`/identities/${id}/revisions/${revisionId}/generate-references`, { method: 'POST', body: input });
export const aprobarRevision = (id: string, revisionId: string) => apiRequest<IdentityDto>(`/identities/${id}/revisions/${revisionId}/approve`, { method: 'POST' });
export const obtenerIdentidadProyecto = (projectId: string) => apiRequest<ProjectIdentityDto | null>(`/projects/${projectId}/identity`);
export const vincularIdentidad = (projectId: string, identityRevisionId: string, expectedRevision: number) =>
  apiRequest<ProjectIdentityDto>(`/projects/${projectId}/identity`, { method: 'PUT', body: { identityRevisionId, expectedRevision } });
export const obtenerBriefCreador = (projectId: string) => apiRequest<CreatorBriefDto | null>(`/projects/${projectId}/creator-brief`);
export const guardarBriefCreador = (projectId: string, input: CreatorBriefInput) =>
  apiRequest<CreatorBriefDto>(`/projects/${projectId}/creator-brief`, { method: 'PUT', body: input });
